module.exports = __webpack_public_path__ + "img/thumbnail_IndianRhinoceros_f_normal.992a1f0e.png";